// PaymentSuccessPage.tsx
import { Container, Grid, Link } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Banner from '../Banner';
import { firebaseConfig } from '../../../Utility/Helper';
import { initializeApp } from "firebase/app";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { toast } from "react-toastify";
import CustomizedProgressBars from '../CustomizedProgressBars';

const PaymentSuccessPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const [urlValid, setUrlValid] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const [data, setData] = useState([]);
  const app = initializeApp(firebaseConfig);
  const storage = getStorage(app);




  // Prevent going back to previous history entry (like the payment page) 
  useEffect(() => {
    // Push current state so we trap “back”
    window.history.pushState(null, '', window.location.href);

    const onPopState = () => {
      // When user presses back, redirect them to a safe page
      // For example: login page or home
      if (id) {
        navigate(`/login/${id}`, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    };

    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [navigate, id]);

  const goToLoginPage = () => {
    navigate(`/login/${id}`, { replace: true });
  };


  


    // if (loading) {
    //   return (
    //     <>
    //       <CustomizedProgressBars />
    //     </>
    //   );
    // }


  return (
    <>

      <Banner />
      <Container sx={{ mt: 2 }}>
        <Grid
          container
          spacing={5}
          alignItems="center"
          justifyContent="center"
          py={1}
        >

          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h2>Payment Successful!</h2>
            <p>
              Thank you for your payment. Your transaction has been completed successfully.<br/><br/>
You may now      <Link onClick={goToLoginPage} color="primary"   style={{
      cursor: "pointer",
      color: "#1976d2",
      textDecoration: "underline",
    }}>
                        Log in
                      </Link>  to access your account.
            </p>
           
          </div>
        </Grid>
      </Container>
    </>
  );
};

export default PaymentSuccessPage;


